<app-auth-card
  [loader]="forgotPasswordComponentLoader"
  [title]="'auth.forgotPassword.title' | translate"
  [description]="'auth.forgotPassword.description' | translate"
>
  <form [formGroup]="editForm" (ngSubmit)="onSubmit()" class="grid grid-cols-1 gap-4">
    <div>
      <label
        [appRequiredLabel]="editForm.controls.email"
        for="email"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.login.email' | translate }}</label
      >
      <input
        pInputText
        id="email"
        type="email"
        autocomplete="username"
        class="w-full"
        formControlName="email"
        [placeholder]="'auth.forgotPassword.email' | translate"
      />
      <app-form-error [control]="editForm.controls.email" />
    </div>

    <p-button
      type="submit"
      [label]="'auth.forgotPassword.sendEmail' | translate"
      icon="pi pi-envelope"
      size="large"
      styleClass="w-full"
    />
  </form>

  <div class="mt-6 text-center">
    <a [routerLink]="['/auth/login']" class="text-primary font-medium no-underline hover:underline">
      {{ 'auth.layout.backToLogin' | translate }}
    </a>
  </div>
</app-auth-card>
